import React from 'react'
import { Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, Icon, useDisclosure, Button } from '@chakra-ui/react'
import { BsCalendar3 } from 'react-icons/bs'
import { IoIosArrowDown } from 'react-icons/io'
import { useWorkdayCalendar } from './hooks/useWorkdayCalendar'
import { CalendarContent } from './components/CalendarContent'

export const WorkdayCalendar = () => {
  const { isOpen, onClose, onToggle } = useDisclosure()
  const {
    workdays,
    currentWorkday,
    calendarDays,
    formatMonthYear,
    navigateToPreviousMonth,
    navigateToNextMonth,
    simulatedDate,
    calendarMonth,
    calendarYear,
    isAdminUser,
    updateSimulatedDate,
    isSimulated,
    resetSimulation,
  } = useWorkdayCalendar()

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom-start" closeOnBlur={true}>
      <PopoverTrigger>
        <Button
          variant="unstyled"
          display="flex"
          alignItems="center"
          height="auto"
          p={2}
          _hover={{ bg: 'gray.100' }}
          borderRadius="md"
          onClick={onToggle}
        >
          <Icon as={BsCalendar3} color="#37F091" boxSize={5} mr={1} />
          <Icon as={IoIosArrowDown} color="#37F091" transition="transform 0.3s" transform={isOpen ? 'rotate(180deg)' : 'rotate(0)'} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        width="auto"
        maxWidth="none"
        borderColor="#37F091"
        boxShadow="0px 0px 2px 1px rgba(55, 240, 145, 0.2)"
        _focus={{ boxShadow: '0px 0px 4px 2px rgba(55, 240, 145, 0.4)', borderColor: '#37F091', outline: 'none' }}
      >
        <PopoverArrow bg="#37F091" />
        <PopoverBody p={0}>
          <CalendarContent
            workdays={workdays}
            calendarDays={calendarDays}
            formatMonthYear={formatMonthYear}
            onPrevMonth={navigateToPreviousMonth}
            onNextMonth={navigateToNextMonth}
            simulatedDate={simulatedDate}
            currentCalendarMonth={calendarMonth}
            currentCalendarYear={calendarYear}
            isAdminUser={isAdminUser}
            updateSimulatedDate={updateSimulatedDate}
            isSimulated={isSimulated}
            resetSimulation={resetSimulation}
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
